<template>
    <q-card class="repo-viewer">
        <!--<q-card-title>-->
            <!--Repozytorium-->
        <!--</q-card-title>-->
        <q-card-main>
            <q-field v-model="filter">
                <q-input v-model="filter" type="text" placeholder="Filtruj po nazwie"/>
            </q-field>

            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showAudio"  v-model="showWhat" val="audio" label="Audio"/>
            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showVideo"  v-model="showWhat" val="video" label="Wideo"/>
            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showPicture"  v-model="showWhat" val="picture" label="Obrazki"/>
            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showSurvey" v-model="showWhat" val="survey" label="Ankiety"/>
            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showArticle"  v-model="showWhat" val="article" label="Artykuły"/>
            <q-radio class="radio" v-if="!hasExternalFilter || extFilter.showBadge"  v-model="showWhat" val="badge" label="Odznaki"/>

            <div class="row">
                <div class="virtualCollectionWrapper" ref="virtualCollectionWrapper">
                    <virtual-collection
                        :collection="filteredItems"
                        :height="virtualHeight"
                        :width="virtualWidth"
                        :cellSizeAndPositionGetter="cellSizeAndPositionGetter"
                    >
                        <GenericViewer
                            slot="cell"
                            slot-scope="props"
                            :tasklet="props.data"
                            :draggable="true"
                            :inline="true"
                            class="col-6"
                            width="150"
                            height="150"/>
                    </virtual-collection>
                </div>


            </div>
        </q-card-main>
    </q-card>
</template>

<script>
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QField from 'quasar-framework/src/components/field/QField'
    import ImageViewer from './viewers/ImageViewer'
    import VideoViewer from './viewers/VideoViewer'
    import SurveyViewer from './viewers/SurveyViewer'
    import GenericViewer from './viewers/GenericViewer'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCheckbox from 'quasar-framework/src/components/checkbox/QCheckbox'
    import _ from 'lodash'
    import { QRadio } from 'quasar-framework'

    const REPO_FILTER_KEY = 'repo-filter';

    export default {
        name: 'RepoViewer',
        components: {
            QCheckbox,
            QCardMain,
            QRadio,
            QCardTitle, QToggle, GenericViewer, SurveyViewer, VideoViewer, ImageViewer, QField, QInput},
        data () {
            return {
                filter: '',
                showPicture: true,
                showVideo: false,
                showSurvey: false,
                showAudio: false,
                showArticle: false,
                showBadge: false,
                filteredItems: [],
                showWhat: 'audio',
                virtualWidth: 0,
                virtualHeight: 0,
                ro: undefined,
            }
        },
        mounted () {
            this.$store.dispatch('fetchAll', {what: 'file'})
            this.$store.dispatch('fetchAll', {what: 'survey'})
            this.$store.dispatch('fetchAll', {what: 'article'})

            this.filter = sessionStorage.getItem(REPO_FILTER_KEY) || '';
            this.f(this.filter);

            this.updateContainerDimensions();

            window.addEventListener('resize', this.updateContainerDimensions, 'false');
            if (window.ResizeObserver) {
                this.ro = new ResizeObserver(this.updateContainerDimensions)
                .observe(this.$refs.virtualCollectionWrapper);
            }

            this.updateExtFilter(this.$store.state.showRightMenu)
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.updateContainerDimensions);
            if (this.ro) {
                this.ro.unobserve(this.$refs.virtualCollectionWrapper);
                this.ro.disconnect();
            }
        },
        methods: {
            // all () {
            //     this.showPicture = true
            //     this.showVideo = true
            //     this.showSurvey = true
            //     this.showAudio = true
            //     this.showArticle = true
            //     this.showBadge = true
            // },
            // none () {
            //     this.showPicture = false
            //     this.showVideo = false
            //     this.showSurvey = false
            //     this.showAudio = false
            //     this.showArticle = false
            //     this.showBadge = false
            // },
            f: _.debounce(function(current) {
                sessionStorage.setItem(REPO_FILTER_KEY, current);
                // this.filteredItems = this.allItems.filter(item => {
                //     return (item.name || item.label || item.title).toLowerCase().
                //         indexOf(current) !== -1
                // })

                const worker = new Worker('repo_filter_worker.js');
                worker.onmessage = event => {
                    this.$nextTick(() => {
                        this.filteredItems = event.data.map(d => ({data: d}));
                    })
                }
                worker.postMessage({items: this.allItems, filter: current});
            }, 1),
            updateContainerDimensions() {
                if (this.$refs.virtualCollectionWrapper) {
                    const maxW = this.$refs.virtualCollectionWrapper.clientWidth;
                    const maxH = window.innerHeight - this.$refs.virtualCollectionWrapper.getBoundingClientRect().top - 20
                    this.virtualWidth = maxW;
                    this.virtualHeight = maxH;
                }
            },
            cellSizeAndPositionGetter(item, index) {
                const partWidth = 150;
                const partHeight = 170;
                const maxCol = Math.floor( this.virtualWidth / partWidth)
                const totalSpace = this.virtualWidth - partWidth * maxCol;

                return {
                    width: partWidth,
                    height: partHeight,
                    x: (index % maxCol) * (partWidth + totalSpace/maxCol),
                    y: parseInt(index / maxCol) * partHeight
                }
            },
            updateExtFilter (current) {
                if (typeof current === 'object') {
                    this.showPicture = current.showPicture
                    this.showVideo = current.showVideo
                    this.showSurvey = current.showSurvey
                    this.showAudio = current.showAudio
                    this.showArticle = current.showArticle
                    this.showBadge = current.showBadge
                } else {
                    this.showPicture = current
                    this.showVideo = current
                    this.showSurvey = current
                    this.showAudio = current
                    this.showArticle = current
                    this.showBadge = current
                }

                this.showWhat = this.showAudio && 'audio'
                    || this.showVideo && 'video'
                    || this.showPicture && 'picture'
                    || this.showSurvey && 'survey'
                    || this.showArticle && 'article'
                    || this.showBadge && 'badge'
                    || '';
            }
        },
        computed: {
            allItems () {
                const items = [
                    ...this.showWhat === 'picture' ? this.$store.getters.pictures : [],
                    ...this.showWhat === 'video' ? this.$store.getters.video : [],
                    ...this.showWhat === 'audio' ? this.$store.getters.audio : [],
                    ...this.showWhat === 'survey' ? this.$store.getters.survey : [],
                    ...this.showWhat === 'article' ? this.$store.getters.article : [],
                    ...this.showWhat === 'badge' ? this.$store.getters.badge : [],
                ];

                return items
            },
            hasExternalFilter () {
                return typeof(this.$store.state.showRightMenu) === 'object'
            },
            extFilter () {
                return this.$store.state.showRightMenu
            }
        },
        watch: {
            extFilter (current) {
                this.updateExtFilter(current)
            },
            filter (current, prev) {
                if (current != prev) {
                    this.f(current)
                }
            },
            allItems () {
                this.f(this.filter)
            }
        }
    }
</script>

<style scoped lang="scss">
    .content > * {
        width: 100%;
    }

    .radio {
        margin-right: 20px;
        width: 80px;
    }

    .virtualCollectionWrapper {
        width: 100%;
        height: 100%;

        .vue-virtual-collection {
            scroll: auto;
        }
    }
</style>